import axios from 'axios';
import { ICirStoreCollection, ICirWeekCollection } from 'common/models/commonModel';
import {
  IMonitorSalesCategorySalesModel,
  IMonitorSalesOosOpportunityLossModel,
  IMonitorSalesParams,
  IMonitorSalesProductRatioModel,
  IMonitorSalesProductSalesModel,
  IMonitorSalesSalesHeatmapModel,
  IMonitorSalesSummaryModel,
} from 'entities/MonitorSales/MonitorSales.models';

const basePath = '/cir-portal/monitor-sales';

export const monitorSalesTransport = {
  getSalesSummary: (params?: IMonitorSalesParams): Promise<IMonitorSalesSummaryModel> =>
    axios.get(`${basePath}/sales-summary`, { params }),

  getProductSales: (params?: IMonitorSalesParams): Promise<IMonitorSalesProductSalesModel> =>
    axios.get(`${basePath}/product-sales`, { params }),

  getCategorySales: (params?: IMonitorSalesParams): Promise<IMonitorSalesCategorySalesModel> =>
    axios.get(`${basePath}/category-sales`, { params }),

  getOosOpportunityLoss: (params?: IMonitorSalesParams): Promise<IMonitorSalesOosOpportunityLossModel> =>
    axios.get(`${basePath}/oos-opportunity-loss`, { params }),

  getSalesHeatmap: (params?: IMonitorSalesParams): Promise<IMonitorSalesSalesHeatmapModel> =>
    axios.get(`${basePath}/sales-heatmap`, { params }),

  getProductRatio: (params?: IMonitorSalesParams): Promise<IMonitorSalesProductRatioModel> =>
    axios.get(`${basePath}/product-ratio`, { params }),

  getStores: (): Promise<ICirStoreCollection> => axios.get(`${basePath}/stores`),

  getWeeks: (): Promise<ICirWeekCollection> => axios.get(`${basePath}/weeks`),
};
